"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initPage = initPage;
const vue_1 = require("vue");
const AccountCreationConfirmModal_vue_1 = __importDefault(require("../vue/AccountCreationConfirmModal.vue"));
function validate() {
    return ValidateEmptyForm(["#email"]);
}
function initPage(props) {
    const form = document.getElementById("owner-form");
    const mountPoint = document.getElementById("account-creation-confirm-modal");
    if (!(form instanceof HTMLFormElement) || !mountPoint) {
        return;
    }
    const ownerForm = form;
    function onConfirm() {
        const submitButton = ownerForm.querySelector(".join-submit-button");
        submitButton?.classList.add("loading");
        ownerForm.submit();
    }
    const app = (0, vue_1.createApp)(AccountCreationConfirmModal_vue_1.default, {
        loginUrl: props.loginUrl,
        onConfirm,
    });
    const modal = app.mount(mountPoint);
    ownerForm.addEventListener("submit", (event) => {
        event.preventDefault();
        if (!validate()) {
            return;
        }
        modal.openModal();
    });
}
